import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-20 sm:py-24">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl sm:text-4xl font-bold mb-4 sm:mb-6">מדיניות פרטיות</h1>
          <p className="text-sm sm:text-base text-muted-foreground mb-2">
            עדכון אחרון: {new Date().toLocaleDateString('he-IL')}
          </p>
          <p className="text-sm text-muted-foreground mb-8">
            מדיניות זו עודכנה בהתאם לחוק הגנת הפרטיות (תיקון 13), התשפ"ה-2025
          </p>

          <div className="prose prose-sm sm:prose-lg max-w-none mb-6 sm:mb-8">
            <p className="text-sm sm:text-base text-foreground leading-relaxed">
              משרד עורכי דין סמירנוב צולר ("המשרד", "אנחנו", "שלנו") מכבד את פרטיותך ומחויב להגן על המידע האישי שלך.
              מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים, משתפים ומאבטחים את המידע שלך.
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-3 sm:space-y-4">
            <AccordionItem value="item-1" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                1. מידע שאנו אוספים
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground space-y-4 pb-4">
                <div>
                  <h4 className="font-medium text-foreground mb-2">מידע שאתה מספק לנו:</h4>
                  <ul className="list-disc pr-5 sm:pr-6 space-y-1 text-sm sm:text-base">
                    <li>פרטים אישיים: שם מלא, כתובת דואר אלקטרוני, מספר טלפון</li>
                    <li>תוכן הפניות והשאלות שלך דרך טפסי יצירת קשר</li>
                    <li>תוכן השיחות עם העוזר המשפטי הווירטואלי (AI)</li>
                    <li>מידע משפטי שאתה משתף במסגרת פנייתך למשרד</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-medium text-foreground mb-2">מידע שנאסף אוטומטית:</h4>
                  <ul className="list-disc pr-5 sm:pr-6 space-y-1 text-sm sm:text-base">
                    <li>כתובת IP</li>
                    <li>סוג דפדפן ומערכת הפעלה</li>
                    <li>דפים שביקרת באתר ומשך הזמן בכל דף</li>
                    <li>מידע מקוכיז (עוגיות) - ראה סעיף מיוחד למטה</li>
                  </ul>
                </div>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                2. מטרות השימוש במידע
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                <p className="mb-3">אנו משתמשים במידע שלך למטרות הבאות:</p>
                <ul className="list-disc pr-5 sm:pr-6 space-y-1 text-sm sm:text-base">
                  <li><strong>מענה לפניותיך:</strong> כדי לספק לך שירות משפטי ולהשיב לשאלותיך</li>
                  <li><strong>שיפור השירות:</strong> ניתוח שימוש באתר כדי לשפר את חווית המשתמש</li>
                  <li><strong>תקשורת:</strong> שליחת עדכונים, מידע משפטי רלוונטי (בהסכמתך)</li>
                  <li><strong>אבטחה:</strong> זיהוי ומניעת הונאות או שימוש לא מורשה</li>
                  <li><strong>חובות חוקיות:</strong> עמידה בדרישות חוק והליכים משפטיים</li>
                </ul>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                3. שיתוף מידע עם צדדים שלישיים
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                <p className="mb-3">אנו לא מוכרים את המידע שלך. אנו עשויים לשתף מידע במקרים הבאים:</p>
                <ul className="list-disc pr-5 sm:pr-6 space-y-2 text-sm sm:text-base">
                  <li>
                    <strong>ספקי שירות:</strong> חברות המספקות שירותים טכניים (אחסון, AI, אנליטיקס).
                    כל הספקים מחויבים לשמור על סודיות ואבטחת המידע.
                  </li>
                  <li>
                    <strong>דרישות חוק:</strong> כאשר נדרש על פי חוק, צו שיפוטי או בקשה רשמית מרשויות.
                  </li>
                  <li>
                    <strong>הגנה על זכויות:</strong> במקרים של הפרת תנאי שימוש או לצורך הגנה על זכויותינו.
                  </li>
                </ul>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-4" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                4. זכויותיך לפי חוק הגנת הפרטיות
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                <p className="mb-3">בהתאם לחוק הגנת הפרטיות (תיקון 13), יש לך את הזכויות הבאות:</p>
                <ul className="list-disc pr-5 sm:pr-6 space-y-2 text-sm sm:text-base">
                  <li><strong>זכות עיון:</strong> לקבל עותק של המידע האישי שלך שבידינו</li>
                  <li><strong>זכות לתיקון:</strong> לבקש תיקון מידע שגוי או לא מדויק</li>
                  <li><strong>זכות למחיקה:</strong> לבקש מחיקת המידע שלך (בכפוף לחובות חוקיות)</li>
                  <li><strong>זכות להעברה:</strong> לקבל את המידע שלך בפורמט מובנה ונפוץ</li>
                  <li><strong>זכות להתנגד:</strong> להתנגד לעיבוד מסוים של המידע שלך</li>
                  <li><strong>זכות לביטול הסכמה:</strong> לבטל הסכמה שניתנה בעבר בכל עת</li>
                </ul>
                <p className="mt-4">
                  להגשת בקשה מכוח זכויות אלו, אנא פנה לדף{' '}
                  <Link to="/data-rights" className="text-primary hover:underline">
                    זכויות נפגע
                  </Link>
                  .
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-5" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                5. אבטחת מידע
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                <p className="mb-3">
                  אנו נוקטים באמצעי אבטחה טכניים וארגוניים כדי להגן על המידע שלך:
                </p>
                <ul className="list-disc pr-5 sm:pr-6 space-y-1 text-sm sm:text-base">
                  <li>הצפנת SSL/TLS לכל התקשורת באתר</li>
                  <li>גישה מוגבלת למידע רק לעובדים מורשים</li>
                  <li>גיבויים קבועים ואחסון מאובטח</li>
                  <li>ניטור ועדכון שוטפים של מערכות האבטחה</li>
                </ul>
                <p className="mt-3">
                  למרות המאמצים, אין אבטחה מושלמת באינטרנט. אנו ממליצים גם לך לנקוט באמצעי זהירות.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-6" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                6. קוכיז (עוגיות)
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                <p className="mb-3">
                  אנו משתמשים בקוכיז כדי לשפר את חווית הגלישה שלך. סוגי הקוכיז:
                </p>
                <ul className="list-disc pr-5 sm:pr-6 space-y-2 text-sm sm:text-base">
                  <li>
                    <strong>עוגיות הכרחיות:</strong> נדרשות לתפעול תקין של האתר (לא ניתן לסרב)
                  </li>
                  <li>
                    <strong>עוגיות אנליטיקה:</strong> עוזרות לנו להבין כיצד מבקרים משתמשים באתר
                  </li>
                  <li>
                    <strong>עוגיות שיווק:</strong> משמשות להצגת תוכן רלוונטי (דורשות הסכמה)
                  </li>
                </ul>
                <p className="mt-3">
                  ניתן לנהל את העדפות הקוכיז שלך בכל עת דרך ההגדרות בתחתית העמוד.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-7" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                7. משך שמירת מידע
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                <p className="mb-3">אנו שומרים את המידע שלך כל עוד:</p>
                <ul className="list-disc pr-5 sm:pr-6 space-y-1 text-sm sm:text-base">
                  <li>אתה לקוח פעיל של המשרד</li>
                  <li>נדרש לצורך עמידה בחובות חוקיות (למשל, שמירת תיקים משפטיים)</li>
                  <li>נדרש להגנה על אינטרסים משפטיים לגיטימיים</li>
                </ul>
                <p className="mt-3">
                  לאחר מכן, המידע יימחק או יאנונם, אלא אם החוק דורש אחרת.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-8" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                8. שימוש בטכנולוגיית AI
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                <p className="mb-3">
                  העוזר המשפטי הווירטואלי שלנו משתמש בטכנולוגיית בינה מלאכותית (AI).
                </p>
                <ul className="list-disc pr-5 sm:pr-6 space-y-1 text-sm sm:text-base">
                  <li>השיחות עם העוזר עשויות להישמר לצורך שיפור השירות</li>
                  <li>המידע מועבר לספקי שירותי AI חיצוניים (בהצפנה מלאה)</li>
                  <li>אל תשתף מידע רגיש מדי בשיחות עם העוזר הווירטואלי</li>
                  <li>המידע שסופק אינו מהווה ייעוץ משפטי מחייב</li>
                </ul>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-9" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                9. פרטי קשר - ממונה על אבטחת מידע
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                <p className="mb-4">
                  לשאלות, בקשות או תלונות בנושא פרטיות ואבטחת מידע, ניתן לפנות אלינו:
                </p>
                <div className="space-y-2 bg-muted/50 p-3 sm:p-4 rounded-lg text-sm sm:text-base">
                  <div className="flex items-center gap-2">
                    <Mail className="h-4 w-4" />
                    <a href="mailto:office@szlaw.co.il" className="text-primary hover:underline">
                      office@szlaw.co.il
                    </a>
                  </div>
                  <div className="flex items-center gap-2">
                    <Phone className="h-4 w-4" />
                    <a href="tel:+97231234567" className="text-primary hover:underline">
                      03-123-4567
                    </a>
                  </div>
                  <p className="text-sm mt-2">
                    כתובת: רח' הבנים 14, תל אביב-יפו, ישראל
                  </p>
                </div>
                <p className="mt-4 text-sm">
                  נענה לפנייתך תוך 30 יום, כנדרש בחוק.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-10" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                10. עדכון מדיניות הפרטיות
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                <p>
                  אנו עשויים לעדכן מדיניות זו מעת לעת. שינויים מהותיים יפורסמו באתר ויכללו
                  תאריך עדכון חדש. המשך שימוש באתר לאחר עדכון מהווה הסכמה למדיניות המעודכנת.
                </p>
              </AccordionContent>
            </AccordionItem>
          </Accordion>

          <div className="mt-8 sm:mt-12 p-4 sm:p-6 bg-muted/30 rounded-lg border">
            <h3 className="text-base sm:text-lg font-semibold mb-3">יש לך שאלות נוספות?</h3>
            <p className="text-sm sm:text-base text-muted-foreground mb-4">
              אנו כאן כדי לעזור. אם יש לך שאלות לגבי מדיניות הפרטיות שלנו או כיצד אנו
              משתמשים במידע שלך, אנא אל תהסס ליצור איתנו קשר.
            </p>
            <div className="flex flex-col gap-2 sm:flex-row sm:gap-3">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center rounded-md bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2"
              >
                צור קשר
              </Link>
              <Link
                to="/data-rights"
                className="inline-flex items-center justify-center rounded-md border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2"
              >
                הגש בקשה לזכויות נפגע
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;